<span
  class="tag"
  [class.tag-linked]="!!route"
  [class.tag-topic]="!route"
  [class.has-icon]="showIcon() && !!tag().model?.icon"
  [attr.role]="route ? 'link' : null"
  [attr.tabindex]="route ? 0 : null"
  (click)="onActivate($event)"
  (keydown.enter)="onActivate($event)"
>
  @if (showIcon() && tag().model?.icon) {
    <img
      [src]="tag().model!.icon"
      [alt]="tag().display_title"
      class="tag-icon"
      width="16"
      height="16"
      loading="lazy"
      decoding="async"
    />
  }
  {{ tag().display_title }}
</span>
